const state = {
  chartColors: [
    '#326bb7', '#bd503c', '#4e741c',
    '#d7b624', '#a33f8c', '#11a6af',
    '#0064ef', '#e82c10', '#9dea29',
    '#fdd31f', '#ee69d0', '#19ffe5',
    '#1d431f', '#f23540', '#E5557E',
    '#53B77D', '#CEA81E', '#A9B4DB',
    '#AC04BB', '#1CEC85', '#97C397',
    '#1A05CE', '#80133A', '#BABBB2'
  ],
  participantDisplayNames: [{
    id: 'participant',
    singular: 'Participant',
    plural: 'Participants',
  }, {
    id: 'client',
    singular: 'Client',
    plural: 'Clients',
  }, {
    id: 'individual',
    singular: 'Individual',
    plural: 'Individuals',
  }, {
    id: 'member',
    singular: 'Member',
    plural: 'Members',
  }, {
    id: 'volunteer',
    singular: 'Volunteer',
    plural: 'Volunteers',
  }, {
    id: 'mentor',
    singular: 'Mentor',
    plural: 'Mentors',
  }, {
    id: 'employer',
    singular: 'Employer',
    plural: 'Employers',
  }, {
    id: 'donor',
    singular: 'Donor',
    plural: 'Donors',
  }, {
    id: 'employee',
    singular: 'Employee',
    plural: 'Employees',
  }, {
    id: 'agency',
    singular: 'Agency',
    plural: 'Agencies',
  }, {
    id: 'organization',
    singular: 'Organization',
    plural: 'Organizations',
  }]
};

const mutations = {

};

const getters = {
  getChartColors: state => {
    return state.chartColors;
  },
  // it's extracted here in case we need to fetch this from server
  getParticipantDisplayNames: state => {
    return state.participantDisplayNames
  },
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/helper.js